import {Injectable, TemplateRef} from "@angular/core";
import {Subject} from "rxjs";

export class RegisteredControl {
    constructor(public field: string, public template: TemplateRef<any>) {
        this.template = template;
    }
}

/**
 * Service used to register the search input components using the ExtendedSearchInputDirective.
 * Also provides other functions for the search extended.
 */
@Injectable()
export class DimensionControlsService {

    currentField: string;

    /**
     * Keeps the list of all form field templates registered
     * @type {Array}
     */
    registeredControls: Array<RegisteredControl> = [];

    /**
     * Event triggered when a control request a form field to be removed
     * @type {EventEmitter}
     */
    requestFormFieldRemoved: Subject<string> = new Subject();

    /**
     * Register a template
     * @param field
     * @param template
     */
    registerTemplate(field: string, template: TemplateRef<any>): void {
        this.registeredControls.push(new RegisteredControl(field, template));
    }

    getRegisteredTemplateRef(field: string): TemplateRef<any> {
        const registeredControl: RegisteredControl = this.registeredControls.find(value => value.field === field);
        return registeredControl != undefined ? registeredControl.template : undefined;
    }

    requestRemoveFormField(field: string): void {
        this.requestFormFieldRemoved.next(field);
    }
}
